<template>

  <div v-if="$route.name === 'EXSBPriceUserDataCreate'">
    <b-row>
      <b-col>
        <router-link :to="{ name: 'EXSBPriceUserDataList' }" class="mb-1 btn btn-sm btn-default float-right">{{ $t('buttons.backToList') }}</router-link>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="card">
          <div class="card-body">
            <b-row>
              <b-col>
                <Form
                  :handle-submit="onSendForm"
                  :values="item"
                  :violations="violations"/>
              </b-col>
            </b-row>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>

  <b-row v-else>
    <b-col>
      <Form
        :handle-submit="onSendForm"
        :values="item"
        :violations="violations"/>
    </b-col>
  </b-row>

</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Form from './Form'
import { checkPagePermission } from '@/utils/checkRoles'

export default {
  name: 'Create',
  components: {
    Form
  },
  data () {
    return {
      item: {
        idItem: '',
        idUserData: '',
        idVatRate: ''
      }
    }
  },
  mounted () {
    if (this.idItem) this.item.idItem = this.idItem
    if (this.idUserData) this.item.idUserData = this.idUserData
  },
  watch: {
    created (val) {
      if (val && this.$route.name === 'EXSBPriceUserDataCreate') {
        this.$router.push({ name: 'EXSBPriceUserDataList' })
      }
    }
  },
  beforeCreate () {
    checkPagePermission('warehouses', 'EXSBPriceUserDataCreate')
  },
  beforeDestroy () {
    this.reset()
  },
  computed: {
    ...mapGetters({
      idItem: 'exsbpriceuserdata/createModal/idItem',
      idUserData: 'exsbpriceuserdata/createModal/idUserData',
      created: 'exsbpriceuserdata/create/created',
      violations: 'exsbpriceuserdata/create/violations',
      isLoading: 'exsbpriceuserdata/create/isLoading'
    })
  },
  methods: {
    onSendForm () {
      this.create(this.item)
    },
    ...mapActions({
      create: 'exsbpriceuserdata/create/create',
      reset: 'exsbpriceuserdata/create/reset'
    })
  }
}
</script>

<style scoped>

</style>
